import { render, staticRenderFns } from "./editProp.vue?vue&type=template&id=3a5e7f32&scoped=true&"
import script from "./editProp.vue?vue&type=script&lang=js&"
export * from "./editProp.vue?vue&type=script&lang=js&"
import style0 from "./editProp.vue?vue&type=style&index=0&id=3a5e7f32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5e7f32",
  null
  
)

export default component.exports